import React from "react";

const Sklenton = () => {
	return (
		<>
			<div className="token-card sklenton">
				<div className="token-card-top-area">
					<div className="token-card-top">
						<span
							className="bg-dark-3"
							style={{ height: "30px", width: "30px" }}
						></span>
						<span
							className="bg-dark-3"
							style={{ height: "30px", width: "30px" }}
						></span>
						<span
							className="bg-dark-3"
							style={{ height: "30px", width: "30px" }}
						></span>
					</div>
					<div className="token-card-middle">
						<div className="img">
							<div
								className="bg-dark-3"
								style={{ height: "74px" }}
							></div>
							<span
								className="bg-dark-3 d-block"
								style={{
									height: "24px",
									width: "70px",
									marginTop: "20px",
								}}
							></span>
						</div>
						<div className="cont">
							<h5
								className="subtitle bg-dark-3 mb-3"
								style={{ height: "24px" }}
							>
								&nbsp;
							</h5>
							<div className="info-grp">
								<span
									className="bg-dark-3 flex-grow-1"
									style={{ height: "24px", width: "70px" }}
								></span>
								<span
									className="bg-dark-3 flex-grow-1"
									style={{ height: "24px", width: "70px" }}
								></span>
								<span
									className="bg-dark-3 flex-grow-1"
									style={{ height: "24px", width: "70px" }}
								></span>
								<span
									className="bg-dark-3 flex-grow-1"
									style={{ height: "24px", width: "70px" }}
								></span>
							</div>
						</div>
					</div>
					<div
						className="description bg-dark-3"
						style={{ height: "44px" }}
					></div>
				</div>
				<ul className="info">
					<li>
						<span
							style={{ height: "14px", width: "100px" }}
							className="bg-dark-3"
						></span>
						<span
							style={{ height: "14px", width: "100px" }}
							className="bg-dark-3"
						></span>
					</li>
					<li>
						<span
							style={{ height: "14px", width: "100px" }}
							className="bg-dark-3"
						></span>
						<span
							style={{ height: "14px", width: "100px" }}
							className="bg-dark-3"
						></span>
					</li>
					<li>
						<span
							style={{ height: "14px", width: "100px" }}
							className="bg-dark-3"
						></span>
						<span
							style={{ height: "14px", width: "100px" }}
							className="bg-dark-3"
						></span>
					</li>
				</ul>
				<div className="token-card-bottom">
					<div className="d-flex justify-content-between align-items-center">
						<span style={{ height: "14px" }} className="bg-dark-3"></span>
						<span
							style={{ height: "14px", width: "100px" }}
							className="bg-dark-3"
						></span>
					</div>
					<div className="progress __progress bg-dark-3">
						<div className="progress-inner"></div>
					</div>
					<div className="d-flex justify-content-between align-items-center">
						<span
							className="bg-dark-3"
							style={{ width: "70px", height: "18px" }}
						></span>
						<span
							className="bg-dark-3"
							style={{ width: "70px", height: "18px" }}
						></span>
					</div>
				</div>
			</div>
		</>
	);
};

export default Sklenton;
